var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3873 11.0729C13.9444 11.5379 11.7882 13.802 11.3076 14.3067C11.0025 14.627 10.5078 14.627 10.2027 14.3067C9.89762 13.9863 9.89762 13.4669 10.2027 13.1465L11.942 11.3203H6.14582C5.71434 11.3203 5.36457 10.9531 5.36457 10.5C5.36457 10.0469 5.71434 9.67969 6.14582 9.67969H11.942L10.2028 7.85351C9.89766 7.53313 9.89766 7.01371 10.2028 6.69338C10.5079 6.37305 11.0026 6.37301 11.3077 6.69338C11.7324 7.13938 13.9711 9.49007 14.3866 9.9264C14.685 10.2472 14.6822 10.7558 14.3873 11.0729ZM20 6.08557V14.9144C20 17.7191 18.1886 19.1434 18.0712 19.3182C17.0384 20.4027 15.665 21 14.2042 21H5.79578C4.335 21 2.96164 20.4027 1.92879 19.3181C1.8127 19.1454 0 17.7194 0 14.9144V6.08557C0 3.28092 1.81137 1.85661 1.92883 1.68185C2.96164 0.597311 4.335 0 5.79578 0H14.2042C15.665 0 17.0384 0.597311 18.0712 1.68189C18.1873 1.85464 20 3.28063 20 6.08557ZM18.4375 6.08557C18.4375 4.03032 17.0851 3.01543 16.9663 2.84197C16.2286 2.06727 15.2476 1.64062 14.2042 1.64062H5.79578C4.75238 1.64062 3.77145 2.06723 3.03367 2.84193C2.91059 3.02166 1.5625 4.01941 1.5625 6.08557V14.9144C1.5625 16.9697 2.91488 17.9846 3.03367 18.158C3.77145 18.9328 4.75238 19.3594 5.79578 19.3594H14.2042C15.2476 19.3594 16.2286 18.9328 16.9663 18.1581C17.0894 17.9783 18.4375 16.9806 18.4375 14.9144V6.08557Z",
    fill: "url(#paint0_linear_81_18)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_18",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#1F7CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#1AC5FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.8d77359e65d544cb01ada27a768e70cf.svg";
export { ForwardRef as ReactComponent };